module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABFklEQVQ4jaWSvyuFURjHP36UIibDLVdkYvAHMNgNLJJBUQqLf+AuVoM/wR1kv2SymEx3MIhBXWVVSikp3fDRuV51e5339d586+mc5znP+Z7vt+egxmJBPVbralWdzOijm9+oADXgCTgFxoFLYDbSS5pxQn1XV1L1I/UmpiBd2FTvI41TfmOkiIU89PzHwnURCyEqalM9SPbn6os6U4RgWq2pH4nnn/VZ3VeH8gjW1Df1TJ1XB5N6Sd1QG+qt2hcjWEpe28n6MGq/Opeud6kDwB1QBXb/mEIJWGzLr3qBdWiNc6/AGAPBVlt+GBScAI/Adod/ooWgYBS4yDgvA6s59+uB4DOxEMMwsJxD8BosjAEPQLNj/cAXd6+1gmuNTU8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/用户管理.png
// module id = d1HN
// module chunks = 1